import { combineReducers } from 'redux';

import list from './assisterListReducer';
import filters from './assisterFiltersReducer';
import pagination from './assisterPaginationReducer';
import navBar from './navBarReducer';
import validation from './validationReducer';
import adminAssisterFilters from './admin/assisterFiltersReducer';

export default combineReducers ({
    list,
    filters,
    pagination,
    navBar,
    validation,    
    adminAssisterFilters
});